import { generateGUID, parseCookies } from "@/components/common/Utils";
import { store } from "@/redux/store";
import { localStorageSetItem } from "@/utils/common";
import axios, { AxiosResponse, AxiosError } from "axios";

interface CustomHeaders {
  Storecode: number;
  Validkey: string;
}
export const BASE_URL = process.env.GATSBY_BASE_URL;
export const VALID_KEY = process.env.GATSBY_VALID_KEY;

const axiosInstance = axios.create({
  baseURL: process.env.GATSBY_BASE_URL,
  headers: {
    Storecode: process.env.GATSBY_STORE_CODE,
    Validkey: process.env.GATSBY_VALID_KEY,
  },
  // timeout: 5000, // Timeout in milliseconds
});
export const axiosWithContext = (context: any) => {
  const realIp =
    context.headers?.get("x-nf-client-connection-ip") ||
    context.headers?.get("x-real-ip") ||
    (context.headers?.get("x-forwarded-for")?.split(",")[0] ?? null);
  console.log("SSR Real IP:", realIp);
  return {
    get: (url: string, config = {}) =>
      axiosInstance.get(url, {
        ...config,
        headers: {
          "x-nf-client-connection-ip": realIp,
        },
      }),

    post: (url: string, data?: any, config = {}) =>
      axiosInstance.post(url, data, {
        ...config,
        headers: {
          "x-nf-client-connection-ip": realIp,
        },
      }),
    put: (url: string, data?: any, config = {}) =>
      axiosInstance.put(url, data, {
        ...config,
        headers: {
          "x-nf-client-connection-ip": realIp,
        },
      }),
    delete: (url: string, data?: any, config = {}) =>
      axiosInstance.delete(url, {
        ...config,
        headers: {
          "x-nf-client-connection-ip": realIp,
        },
      }),
  };
  // return {
  //   get: (url: string, config = {}) => axiosInstance.get(url, { ...config, context } as any),
  //   post: (url: string, data?: any, config = {}) => axiosInstance.post(url, data, { ...config, context } as any),
  //   put: (url: string, data: any, config = {}) => axiosInstance.put(url, data, { ...config, context } as any),
  //   delete: (url: string, config = {}) => axiosInstance.delete(url, { ...config, context } as any),
  // };
};
axiosInstance.interceptors.request.use(
  (config: any) => {
    const { isLoggedIn: isLoggedInFromStore, userDetails } = store.getState().homePage;
    let uniqueSessionId: string;
    let isLoggedIn: boolean;
    let cookieString: string = "";
    let cookies: any = {};

    if (config.context) {
      cookieString = config.context?.headers?.get('cookie') || '';
    } else if (typeof window !== 'undefined') {
      cookieString = document.cookie || '';
    }

    cookies = parseCookies(cookieString);
    isLoggedIn = cookies.isLoggedIn === 'true';

    if (isLoggedInFromStore) {
      isLoggedIn = isLoggedInFromStore
    }

    uniqueSessionId = userDetails?.customerGuid ?? cookies.uniqueSessionId; // No need to generate a new ID here

    if (!uniqueSessionId || uniqueSessionId.includes('undefined')) {
      uniqueSessionId = userDetails?.customerGuid && !userDetails?.customerGuid?.includes('undefined') ? userDetails?.customerGuid : generateGUID(); // Generate only on the client-side if it doesn't exist
      if (typeof window !== 'undefined') {
        document.cookie = `uniqueSessionId=${uniqueSessionId}; path=/; max-age=${7 * 24 * 60 * 60}`; // Set the cookie for 7 days
      } else if (config?.context?.res?.setHeader) {
        config?.context?.res?.setHeader?.('Set-Cookie', `uniqueSessionId=${uniqueSessionId}; Path=/; Max-Age=${7 * 24 * 60 * 60}`);
      }
    }

    config.headers["LogInUser"] = isLoggedIn ? "true" : "false";
    config.headers["SessionId"] = uniqueSessionId;
    if (userDetails?.token) {
      config.headers.Authorization = `Bearer ${userDetails?.token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);


// Response interceptor
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    // You can handle successful responses here
    return response;
  },
  (error: AxiosError) => {
    const status = error?.response?.status;

    if (status === 401) {
      // 🔹 Clear auth data
      if (typeof window !== "undefined") {
        localStorageSetItem('isLoggedIn', JSON.stringify(false))
        localStorageSetItem('userDetails', null)
        // 🔹 Redirect to login
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
